import loadable from "@loadable/component";
import CreateIcon from "../../Icons/Create";
import APIS from "../../constant/EndPoint";
import { useParams } from "react-router";
import usePatchHook from "../../customHooks/usePatchHook";
import useGetHook from "../../customHooks/useGetHook";
import Spinner from "../../components/Reusable/Spinner";

const EditBranchComponent = loadable(
  () => import("../../components/Branch/EditBranch")
);
const EditBranch = () => {
  const { id } = useParams()

  const { data:branchData, isLoading } = useGetHook({
    queryKey: [`branch-${id}`],
    url: `${APIS.BRANCH}${id}/`,
    params: {},
  });



  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["Branch"],
    navigateURL: "/branch",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.BRANCH}${id}/`;
    let formData = {
      ...values,
      "primary_contact": `+977${values?.primary_contact}`,
      "secondary_contact":values?.secondary_contact? `+977${values?.secondary_contact}`: `+977${values?.mobile_number}`,
      "covered_city": values?.covered_city? values?.covered_city?.map((item:any)=>(item.value)):[]
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Edit Branch</span>
      </div>
      {isLoading?<Spinner/>:
      <EditBranchComponent
        isLoading={isPatchLoading}
        handleEdit={handleEdit}
        branchData={branchData}
      />
    }

    </>
  );
};
export default EditBranch;
